import { render } from "./ProdutosEstoque.vue?vue&type=template&id=8adb26f8&scoped=true"
import script from "./ProdutosEstoque.vue?vue&type=script&lang=js"
export * from "./ProdutosEstoque.vue?vue&type=script&lang=js"

import "./ProdutosEstoque.vue?vue&type=style&index=0&id=8adb26f8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.goncalves\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8adb26f8"]])

export default __exports__